import { Match, RootState, Status } from '../types';

export const getMatchesStatus = (state: RootState): Status => state.matches.status;

export const getMatchesErrorMsg = (state: RootState): string | null => state.matches.errorMsg;

export const getMatchesTotalCount = (state: RootState): number => state.matches.totalCount;

export const getMatches = (state: RootState): Match[] => state.matches.matches;
